import { styled } from "@mui/material";
import { notEmpty } from "../../../utils/not-empty";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";

import type { EmailHeadingTextSettings } from "../../email-design/types/email-text-type";
import type { PreviewProps } from "./types";
import type { FC } from "react";

export const TextPreview: FC<PreviewProps> = (props) => {
  const { text_settings, layout_settings } = props.data;

  const fontFamily = [text_settings?.font, text_settings?.fallback_font].filter(notEmpty);

  const Paragraph = styled("p")`
    margin: 0;

    padding: 0 0 ${layout_settings?.paragraph_padding}px 0;
    font-family: ${fontFamily.join(", ")};
    font-size: ${text_settings?.font_size}px;
    color: ${text_settings?.font_colour};
    line-height: ${text_settings?.line_height}em;
  `;

  const headerFontFamily = [
    text_settings?.header_font,
    text_settings?.header_fallback_font,
    ...fontFamily,
  ];

  const Heading = styled("h1")(
    ({
      heading = {
        font_size: 16,
        bold: true,
        font_colour: text_settings?.font_colour ?? "#000",
      },
    }: {
      heading?: Partial<EmailHeadingTextSettings>;
    }) => `
    margin: 0;
    font-family: ${headerFontFamily.join(", ")};
    font-size: ${heading?.font_size ?? "24"}px;
    font-weight: ${heading?.bold === true ? "600" : "400"};
    color: ${heading?.font_colour ?? text_settings?.font_colour ?? "#000"};
  `,
  );

  const Link = styled("a")(`
    color: ${text_settings?.link_color ?? "inherit"};
  `);
  return (
    <ConditionalWrapper
      condition={props.badgeProps !== undefined}
      wrapper={(children) => (
        <HoverBadge badgeContent="Text" name="text" {...props.badgeProps}>
          {children}
        </HoverBadge>
      )}
    >
      <>
        <Heading heading={text_settings?.heading1}>Heading 1</Heading>
        <Paragraph>
          Lorem
          <Link href="https://example.com" onClick={(e) => e.preventDefault()}>
            ipsum dolor
          </Link>{" "}
          sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
          dolore magna aliqua. Fringilla urna porttitor rhoncus dolor purus non enim praesent.
        </Paragraph>
        <Heading heading={text_settings?.heading2}>Heading 2</Heading>
        <Paragraph>
          Vehicula ipsum a arcu cursus vitae congue mauris rhoncus. Orci eu lobortis elementum nibh.
          Pulvinar etiam non quam lacus suspendisse faucibus interdum. Nulla aliquet enim tortor at
          auctor.
        </Paragraph>
        <Heading heading={text_settings?.heading3}>Heading 3</Heading>
        <Paragraph>
          Lectus vestibulum mattis ullamcorper velit sed. Amet nisl purus in mollis nunc sed id
          semper. Lacus viverra vitae congue eu consequat ac felis donec.
        </Paragraph>
        <Heading heading={text_settings?.heading4}>Heading 4</Heading>
        <Paragraph>
          Lectus vestibulum mattis ullamcorper velit sed. Amet nisl purus in mollis nunc sed id
          semper. Lacus viverra vitae congue eu consequat ac felis donec.
        </Paragraph>
      </>
    </ConditionalWrapper>
  );
};
